import React from "react";
import "../About/About.css";
import vision_icon from "../Assets/icons8-vision-100.png";
import mission_icon from "../Assets/mission_icon.png";
import services_icon from "../Assets/services_icon.png";
import solution_icon from "../Assets/solution_icon.png";
import image from "../Assets/ai-image.jpg";
import { motion } from "framer-motion";

function About() {
  return (
    <>
      <div className="about">
        <h2>
          About Us
          <hr />
        </h2>
        <p>
          Medisol-Lab is a speciality company and a full-service cGLP compliant
          laboratory specializing in analytical testing of a range of drug
          delivery systems from early stage of development to commercialization.
        </p>

        <div className="about-Container">
          <motion.div
            initial={{ opacity:0 }}
            transition={{ ease: "easeOut", duration: 6 }}
            whileInView={{ opacity: 1 }}
            className="about-div2"
          >
            <img src={image} alt="img" className="about-div2-img" />
          </motion.div>
          <div className="about-div1">
            <div className="about-div-row1">
              <motion.div
                initial={{ opacity: 0 ,scale:0}}
                transition={{ ease: "easeIn", duration: 1 }}
                whileInView={{ opacity: 1 ,scale:1}}
                className="about-contain-card"
              >
                <img src={vision_icon} alt="" className="about-card-icon" />
                <h2>Vision</h2>
                <p className="about-card-text">
                  To be an integrated CRO with global distinction, aiming for
                  long term partnerships with our customers based on shared
                  benefits and goals for synergistic growth.
                </p>
              </motion.div>
              <motion.div
                initial={{ opacity: 0 ,scale:0}}
                transition={{ ease: "easeIn", duration: 1.1 }}
                whileInView={{ opacity: 1 ,scale:1}}
                className="about-contain-card"
              >
                <img src={mission_icon} alt="" className="about-card-icon" />
                <h2>Mission</h2>
                <p className="about-card-text">
                  At Medisol-Lab our mission is to deliver Value added, Reliable
                  and cost-effective solution to our customers through our core
                  values.
                </p>
              </motion.div>
            </div>

            <div className="about-div-row1">
              
              <motion.div
                initial={{ opacity: 0 ,scale:0}}
                transition={{ ease: "easeIn", duration: 1.2 }}
                whileInView={{ opacity: 1 ,scale:1}}
                className="about-contain-card"
              >
                <img src={solution_icon} alt="" className="about-card-icon" />
                <h2>Bespoke solutions</h2>
                <p className="about-card-text">
                  Utilizing our global regulatory expertise, we develop a
                  specific scientific program to meet your in-vitro
                  Bio-equivalence requirements
                </p>
              </motion.div>
              <motion.div
                initial={{ opacity: 0 ,scale:0}}
                transition={{ ease: "easeIn", duration: 1.3 }}
                whileInView={{ opacity: 1 ,scale:1}}
                className="about-contain-card"
              >
                <img src={services_icon} alt="" className="about-card-icon" />
                <h2>Services</h2>
                <p className="about-card-text">
                  Our state of the art laboratory provides comprehensive
                  solutions for the product development process from
                  formulation, CMC support, drug product characterization,
                  regulatory submission requirements, finished product batch
                  release and post approval stability to regulatory agencies
                  worldwide.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default About;
